<template>
    <div id="scope_rate_view" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptInvoiceHeader">Scope Rate View</span>
                    <div class="btn-groups text-right">
                        <!-- <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackReceiptList" >
                            <i class="fp-back"> </i> Back
                        </button> -->
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content receipt-item-view">
                        <template>
                        <section class="internal-container border-top-table-fl">
                            <form class="form-horizontal basic-form-container metric-form" id="ReceiptInvoiceMapperForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="receipt">Asset Type:</label>
                                        <span class="label">{{truckType}}</span>
                                    </div>
                                </div>

                                <div class="purchase-order-create-main table-responsive-sm" v-if="rows && rows.length > 0">
                                    <!--purchase table-->
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width:120px;">Section</th>
                                                <th scope="col">Rate Type</th>
                                                <th scope="col">Rate</th>
                                                <th scope="col">Discount</th>
                                                <th scope="col">Total</th>
                                                <th scope="col">Discount Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    {{row.sectionRateId.text}}
                                                </td>
                                                <td>
                                                    {{row.rateType.text}}
                                                </td>
                                                <td v-if="row.rate">
                                                    ${{row.rate}}
                                                </td>
                                                <td v-if="row.discount">
                                                    ${{row.discount}}
                                                </td>
                                                <td v-if="row.total">
                                                    ${{row.total}}
                                                </td>
                                                <td>
                                                    <span v-if="row.reason.text">
                                                        {{row.reason.text}}
                                                    </span>
                                                    <span v-else>
                                                        -
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </section>

                        </template>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "ScopeRateView",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "View Scope Rate | " +process.env.COPYRIGHT_NAME : "View Scope Rate | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    rows:[],
    truckType:'',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.scopeRateid = segments[3];
                self.getRateForTruckType(segments[3]);
            }

        }, 100);

        // self.fetchBanks();
  },
  methods: {

    BackReceiptList() {
      var self = this;
      if (self.$route.params.id != undefined && self.$route.params.id > 0){
        self.$router.push("/receipt-item/list");
      }else{
        self.$router.push("/payment-receipt/list");
      }

    },

    getRateForTruckType: function(search){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/existing-scoperate/fetch",
            type: "POST",
            headers: this.ajxHeaders,
            data:{
                id:search,
                agreementId:self.$route.query.ag,
                truckTypeId:0,
                from:'view',
                contractTypeId:0
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.truckType = data.content.truckType.text;
                    self.rows = data.content.items;
                } else{
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },
  }
};
</script>
<style scoped>
.right-adjust{
    width: 50%!important;
    float: right;
    height: 38px;
    padding-right: 8px;
    border-bottom: 1px solid !important;
    border-bottom-color: #8080802e !important;
}
.overClass{
    overflow: visible !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ScopeRateView.vue